export const AR = {
    header: 'خدماتنا',

    park: 'لاند سكيب وتنسيق حدائق',
    park_des: 'إن مزيج خضرة النباتات مع ألوان الزهور يريح المواطن من مشاكله وهمومه الحياتية مما يساعده على تجديد نشاطه وحيويته وزيادة قدرته على العطاء والإنتاج ولذلك أولينا اهتماما خاصا بخدمة تنسيق الحدائق بإشراف مهندس محترف ومتميز',

    outer: 'التصاميم الخارجيه',
    outer_des: 'يحدد التصميم الخارجي مدى انسجام المبنى من الداخل والخارج ومع الجوار المحيط، بالإضافة إلى تأثيره إيجابًا على وظائف المبنى، من خلال التخطيط الجيد للتصميم الخارجي وإنشاء مساحات خارجية عمليّة وجميلة',

    area: 'خدمات هندسه المساحه',
    area_des: 'الرفع المساحي ينتج عندما يتم الإعداد لعمل القرار المساحي وهو بمثابة الخريطة التي يتم طباعتها على الأرض، ومن شأنها أن توضح كافة جهات وقياسات الأرض سواء الأبعاد أو المساحة الكلية والارتفاع',

    build: 'الاعمال الإنشائية',
    build_des: '',

    finish: 'أعمال الترميم',
    finish_des: 'تتأثر العديد من البنايات بالعوامل الزمنية، حيث تبدأ بعض الشروخ والتصدعات في الظهور مما قد يعرض المبنى للانهيار، وهذا من شأنه الإضرار بسلامة السكان والمباني المجاورة؛ هنا يأتي دورنا الهندسي لمعرفة طرق الإصلاحات اللازم تنفيذها لضمان سلامة المبنى والمحافظة عليه وعلي ساكنيه',

    internal: 'التصاميم الداخليه',
    internal_des: 'تكمن أهمية التصميم الداخلي في استغلال المساحة المتاحة للمكان بأفضل شكل بناءً على الوظيفة واحترافية فريق عملنا في التصميم',

    look: 'الإشراف والتنفيذ',
    look_des: '',

    contact: 'تواصل معنا',
    contact_des: 'company@decore-gate.com',
    
    btn: 'المزيد'
}

export const USA = {
    header: 'Services',
    park: 'Landscape and garden',
    park_des: 'The combination of green plants with the colors of flowers relieves the citizen from his problems and life worries, which helps him to renew his activity and vitality and increase his ability to give and produce. Therefore, we have paid special attention to the garden coordination service under the supervision of a professional and distinguished engineer.',

    outer: 'Exterior designs',
    outer_des: 'The exterior design determines the extent to which the building harmonizes with the interior and exterior and with the surrounding neighborhood, in addition to its positive impact on the functions of the building, through good planning of the exterior design and the creation of practical and beautiful outdoor spaces',

    area: 'Surveying engineering',
    area_des: 'The surveying is produced when the surveying decision is prepared. It is like a map that is printed on the ground, and it is intended to clarify all aspects and measurements of the land, whether dimensions, total area, or height',

    build: 'Construction works',
    build_des: '',

    finish: 'Restoration works',
    finish_des: 'Many buildings are affected by time factors, as some cracks and fissures begin to appear, which may expose the building to collapse, and this may harm the safety of residents and neighboring buildings; here comes our engineering role to know the methods of repairs that must be implemented to ensure the safety of the building and preserve it and its residents',

    internal: 'Interior designs',
    internal_des: 'The importance of interior design lies in making the best use of the available space based on the function and the professionalism of our design team',

    look: 'Supervision',
    look_des: '',

    contact: 'Contact us',
    contact_des: 'company@decore-gate.com',

    btn: 'More'
}
